var Backbone = require('backbone');

require('./PopupSections.less');

module.exports = Backbone.View.extend({
    template: require('./PopupSections.jinja'),

    events: {
        'click .PopupSections-btn': 'hide'
    },

    initialize: function () {
        app.vent.on('PopupSections--show', this.show.bind(this));
    },

    render: function () {
        var $html = $(this.template.render({
            render: true,
            sections: app.data.sections
        }));

        var el = $html.appendTo(app.els.$body);
        this.setElement(el);

        this.$inner = this.$('.PopupSections-inner');

        return this;
    },

    show: function () {
        app.vent.trigger('Popup-startOpening');

        this.render();

        this.adjustElements();

        // For IE 11 to update position of Nav
        app.stickyfill.rebuild();

        $.Velocity(this.$el[0], 'fadeIn');

        app.els.$window.scrollTop(0);
    },

    adjustElements: function () {
        if (app.els.$contentTopAd.length) {
            var adOffset = app.els.$contentTopAd.offset().top;
        }
        var bodyOffset = app.els.$contentBody.offset().top;
        var footerOffset = app.els.$contentFooter.offset().top;

        this.scrollTop = app.els.$window.scrollTop();

        app.els.$contentTopNav.css({
            position: 'fixed',
            top: -this.scrollTop + app.els.$contentTopNav.offset().top,
            left: 0,
            right: 0
        });

        if (app.els.$contentTopAd.length) {
            app.els.$contentTopAd.css({
                position: 'fixed',
                top: -this.scrollTop + adOffset,
                left: 0,
                right: 0
            });
        }

        app.els.$contentBody.css({
            position: 'fixed',
            top: -this.scrollTop + bodyOffset,
            left: 0,
            right: 0
        });

        app.els.$contentFooter.css({
            position: 'fixed',
            top: -this.scrollTop + footerOffset,
            left: 0,
            right: 0
        });
    },

    hide: function () {
        app.els.$contentTopNav.removeAttr('style');
        app.els.$contentTopAd.removeAttr('style');
        app.els.$contentBody.removeAttr('style');
        app.els.$contentFooter.removeAttr('style');

        app.els.$window.scrollTop(this.scrollTop);

        // For IE 11 to update position of Nav
        app.stickyfill.rebuild();

        $.Velocity(this.$el[0], 'fadeOut')
            .then(function () {
                this.$el.remove();
            }.bind(this));
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/PopupSections/PopupSections.js
// module id = 154
// module chunks = 0